import React from 'react'
import { AiFillAppstore } from "react-icons/ai";
// import { FaMobile, FaGlobe } from "react-icons/fa";
import { SiAntdesign } from "react-icons/si";
import Title from '../layouts/Title';
import Card from './Card';

const Services = () => {
  return (
    <section
      id="services"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="My Services" des="Services" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="FrontEnd Website"
          des="Mewujudkan desain menjadi website responsif dan interaktif dengan performa terbaik."
          icon={<AiFillAppstore />}
        />
        <Card
          title="UIUX Design"
          des="Merancang antarmuka yang menarik dan intuitif, berfokus pada pengalaman pengguna yang optimal."
          icon={<SiAntdesign />}
        />
        <Card
          title="Wordpress Website"
          des="Membangun website WordPress yang mudah dikelola dan sesuai kebutuhan."
         
        />
        {/* <Card
          title="SEO Optimisation"
          des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque soluta
          hic consequuntur eum repellendus ad."
          icon={<SiProgress />}
        />
        <Card
          title="Mobile Development"
          des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque soluta
          hic consequuntur eum repellendus ad."
          icon={<FaMobile />}
        />
        
        <Card
          title="Hosting Websites"
          des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque soluta
          hic consequuntur eum repellendus ad."
          icon={<FaGlobe />}
        /> */}
      </div>
    </section>
  );
}

export default Services